import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycDeclinedPage from './KycDeclinedPage';

const KycDeclinedRoute: FuseRouteItemType = {
  path: '',
  element: <KycDeclinedPage />,
  auth: AUTH_ROLES.parent, // []
};

export default KycDeclinedRoute;
